import { SVGProps } from 'react';

const OpenLetterCheck = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M20.47 16.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06L17 19.94l3.47-3.47ZM20.25 13V8.401l-7.834 5.223a.75.75 0 0 1-.832 0L3.75 8.401V17A1.25 1.25 0 0 0 5 18.25h6a.75.75 0 0 1 0 1.5H5A2.75 2.75 0 0 1 2.25 17V7A2.75 2.75 0 0 1 5 4.25h14A2.75 2.75 0 0 1 21.75 7v6a.75.75 0 0 1-1.5 0ZM5 5.75a1.25 1.25 0 0 0-1.196.885L12 12.099l8.195-5.464a1.25 1.25 0 0 0-1.071-.88L19 5.75H5Z"
    />
  </svg>
);

export default OpenLetterCheck;
